import React, {PureComponent} from 'react';
import * as ReactGA from '../../GA';
import {Menu, MenuItem} from '../../atoms/Menu';
import SportSpecificProgressivesSlide from './SportSpecificProgressivesSlide';
import i18n from '../../locales/i18n';

import './SportSpecificProgressives.css';

const SPORTS = {
    cycling: [
        SportSpecificProgressivesSlide,
        'sport_specific_progressives.cycling.title',
        'sport_specific_progressives.cycling.description',
        require('./cycling/cycling-background.jpg'),
        require('./cycling/cycling-frame.png'),
    ],
    golf: [
        SportSpecificProgressivesSlide,
        'sport_specific_progressives.golf.title',
        'sport_specific_progressives.golf.description',
        require('./golf/golf-background.jpg'),
        require('./golf/golf-frame.png'),
    ],
    angling: [
        SportSpecificProgressivesSlide,
        'sport_specific_progressives.angling.title',
        'sport_specific_progressives.angling.description',
        require('./angling/angling-background.jpg'),
        require('./angling/angling-frame.png'),
    ],
};

export default class SportSpecificProgressives extends PureComponent {
    state = {
        type: 'cycling',
        frame: null,
    };

    static getDerivedStateFromProps(props, state) {
        //console.log(props.match.params.type, state.type, state.frame);
        if (props.match.params.type !== state.type) {
            //console.log('diverso');
            return {
                type: props.match.params.type,
                frame: null,
            };
        }

        return null;
    }

    componentDidMount() {
        ReactGA.pageview(
            `${i18n.language}/SportSpecificProgressives/${
                this.props.match.params.type
            }/${this.state.frame ? this.state.frame : '0'}`
        );
    }
    componentDidUpdate() {
        ReactGA.pageview(
            `${i18n.language}/SportSpecificProgressives/${
                this.props.match.params.type
            }/${this.state.frame ? this.state.frame : '0'}`
        );
    }

    changeGlasses = frame => {
        this.setState({
            frame: frame,
        });
    };

    render() {
        const currentSport = SPORTS[this.props.match.params.type];
        const CurrentSportComponent = SPORTS[this.props.match.params.type][0];

        const menuItems = Object.keys(SPORTS).map(item => (
            <MenuItem
                key={item}
                tag={SPORTS[item][1]}
                onClick={() =>
                    this.props.history.replace(
                        `/sport-specific-progressives/${item}`
                    )
                }
                active={this.props.match.params.type === item}
            />
        ));

        return (
            <article className="SportSpecificProgressives">
                <CurrentSportComponent
                    title={currentSport[1]}
                    description={currentSport[2]}
                    bg={currentSport[3]}
                    glasses={currentSport[4]}
                    changeGlasses={this.changeGlasses}
                    type={this.state.type}
                    frame={this.state.frame}
                />
                <Menu>{menuItems}</Menu>
            </article>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/sportSpecificProgressives/SportSpecificProgressives.js